import { render, staticRenderFns } from "./Messagedetail.vue?vue&type=template&id=ef32d25a&scoped=true"
import script from "./Messagedetail.vue?vue&type=script&lang=js"
export * from "./Messagedetail.vue?vue&type=script&lang=js"
import style0 from "./Messagedetail.vue?vue&type=style&index=0&id=ef32d25a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef32d25a",
  null
  
)

export default component.exports